// api.js
//export const API_BASE_URL = 'https://housing.vpmrd.in/api/v1';


  export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'https://housing.vpmrd.in/api/v1';

export const APP_BASE_URL =
  API_BASE_URL.replace(/\/api\/v1\/?$/, '');

export const INSPECTION_IMAGE_BASE_URL =
  `${API_BASE_URL}/uploads/inspection`;